import React, { Component } from 'react'
import CustomPieZoomChart from '../../../../../components/ui/charts/zoom/CustomPieZoomChart'
import PropTypes from 'prop-types'
import InfoButton from '../../../../../components/ui/buttons/InfoButton'

class EducationDetailChart extends Component {
  static propTypes = {
    chartData: PropTypes.any,
    header: PropTypes.string,
    tipContent: PropTypes.string,
    elementId: PropTypes.string.isRequired,
    isMobile: PropTypes.bool,
    isInteger: PropTypes.bool,
  }

  render() {
    const { chartData, header, tipContent, isMobile, elementId, isInteger } = this.props

    return (
      <div style={{ padding: isMobile ? 5 : 20, maxHeight: 500 }}>
        {header && (
          <h3 style={isMobile && { marginBottom: 0 }}>
            {header}
            <span className="pull-right">
              <InfoButton content={tipContent} styles={{ color: '#808080' }} />
            </span>
          </h3>
        )}{' '}
        <CustomPieZoomChart
          chartData={chartData}
          legend={isMobile ? false : true}
          labels={isMobile ? true : false}
          height={400}
          outerMargin={50}
          elementId={elementId}
          isInteger={isInteger}
        />
      </div>
    )
  }
}

export default EducationDetailChart



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/components/EducationDetailChart.js